export default __webpack_public_path__ + "static/media/ian-circle.db02b65d.png";